'use client'

import { buildRevokeAssertionWrite } from '~/app/accounting/lot-assertion-writes'
import { LotRow } from '~/app/accounting/lot-rows'
import { useLotAssertionWrite } from '~/app/accounting/useLotAssertionWrite'
import { SplitsDialogContent } from '~/components/component-library/Dialog'

/**
 * Withdraws every edit asserted against a lot. The overlay is append-only, so
 * this writes a revoke row rather than deleting anything: the full history
 * stays auditable, and the lot returns to its derived values on the next
 * recompute.
 */
export const RevokeLotEditDialog = ({ lot }: { lot: LotRow }) => {
  const { writeAssertion, isProcessing } = useLotAssertionWrite()
  const write = buildRevokeAssertionWrite(lot)

  const revoke = async () => {
    if (!write) return
    await writeAssertion({
      assertion: write,
      successMessage: 'Edits revoked',
      successDescription: 'The lot will return to its original values soon',
      errorMessage: 'Failed to revoke lot edits',
    })
  }

  return (
    <SplitsDialogContent
      id="revokeLotEdit"
      variant="destructive"
      title={`Revoke edits on lot ${lot.lotNumber}?`}
      isLoading={isProcessing}
      deleteButton={{ text: 'Revoke edits', onClick: revoke }}
    >
      <p>
        This lot will return to its original price and date shortly. A record of
        past edits is kept for auditing.
      </p>
    </SplitsDialogContent>
  )
}
